// @ts-nocheck
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { sx } from '../sx';

const WIDTH = 300;
const GAP = 6;
const TONE = { actual: '#0052CD', forecast: '#C98A00' };

const CohortCellCard = forwardRef(function CohortCellCard(_props, ref) {
  const [card, setCard] = useState(null);

  useImperativeHandle(ref, () => ({
    show(explain, el) {
      if (!explain || !el) return;
      const r = el.getBoundingClientRect();
      const left = Math.max(8, Math.min(r.right - WIDTH, window.innerWidth - WIDTH - 8));
      const below = r.bottom + 260 < window.innerHeight;
      setCard({ explain, left, top: below ? r.bottom + GAP : r.top - GAP, below });
    },
    hide() {
      setCard(null);
    },
  }), []);

  if (!card) return null;
  const { explain: e, left, top, below } = card;

  return (
    <div role="tooltip" style={sx(`position:fixed;left:${left}px;top:${top}px;${below ? '' : 'transform:translateY(-100%);'}z-index:80;width:${WIDTH}px;padding:12px 14px;border:1px solid #DCE4F2;border-radius:12px;background:#fff;box-shadow:0 12px 28px -12px rgba(8,35,76,0.35);color:var(--ink-2);font-size:11.5px;line-height:1.45;pointer-events:none;text-align:left`)}>
      <div style={sx(`display:flex;align-items:baseline;gap:8px`)}>
        <span style={sx(`flex:1;font-size:10.5px;font-weight:600;letter-spacing:0.08em;text-transform:uppercase;color:#0052CD`)}>{e.title}</span>
        {e.result ? <span style={sx(`flex:none;font-size:13px;font-weight:600;color:var(--ink);font-variant-numeric:tabular-nums`)}>{e.result}</span> : null}
      </div>
      {e.rows && e.rows.length ? (
        <div style={sx(`margin-top:8px;display:flex;flex-direction:column;gap:5px`)}>
          {e.rows.map((row, i) => (
            <div key={i} style={sx(`display:flex;align-items:flex-start;gap:8px`)}>
              <span style={sx(`flex:none;width:9px;height:9px;margin-top:4px;border-radius:2px;background:${TONE[row.tone] || 'transparent'}`)}></span>
              <span style={sx(`flex:1;min-width:0;color:var(--ink-3)`)}>
                {row.label}
                {row.sub ? <span style={sx(`display:block;font-size:10.5px;color:var(--ink-4)`)}>{row.sub}</span> : null}
              </span>
              <span style={sx(`flex:none;font-weight:500;color:var(--ink);font-variant-numeric:tabular-nums`)}>{row.value}</span>
            </div>
          ))}
        </div>
      ) : null}
      {e.steps && e.steps.length ? (
        <div style={sx(`margin-top:9px;padding:7px 9px;border-radius:8px;background:#F5F8FD;display:flex;flex-direction:column;gap:3px`)}>
          {e.steps.map((s, i) => (
            <span key={i} style={sx(`font-size:11px;color:var(--ink-2);font-variant-numeric:tabular-nums;word-break:break-word`)}>{s}</span>
          ))}
        </div>
      ) : null}
      {e.guards && e.guards.length ? (
        <div data-testid="cohort-cell-guards" style={sx(`margin-top:9px;display:flex;flex-direction:column;gap:4px`)}>
          <span style={sx(`font-size:10px;font-weight:600;letter-spacing:0.08em;text-transform:uppercase;color:var(--ink-4)`)}>Guardrails applied</span>
          {e.guards.map((g, i) => (
            <span key={i} style={sx(`font-size:11px;color:var(--ink-2);word-break:break-word`)}>
              <b style={sx(`font-weight:600;color:var(--ink)`)}>{g.label}</b>{g.text ? ' · ' + g.text : ''}
            </span>
          ))}
        </div>
      ) : null}
      {e.flags && e.flags.length ? (
        <div data-testid="cohort-cell-flags" style={sx(`margin-top:9px;padding:7px 9px;border-radius:8px;background:#FDECEC;display:flex;flex-direction:column;gap:3px`)}>
          {e.flags.map((f, i) => (
            <span key={i} style={sx(`font-size:11px;color:#B42318;word-break:break-word`)}>
              <b style={sx(`font-weight:600`)}>{f.label}</b>{f.text ? ' · ' + f.text : ''}
            </span>
          ))}
        </div>
      ) : null}
      {e.review ? <div data-testid="cohort-cell-review" style={sx(`margin-top:9px;padding:7px 9px;border-radius:8px;background:#E5F5EC;font-size:11px;color:#0F7A55;word-break:break-word`)}>{e.review}</div> : null}
      {e.note ? <div style={sx(`margin-top:7px;font-size:10.5px;color:var(--ink-4)`)}>{e.note}</div> : null}
    </div>
  );
});

export default CohortCellCard;
